import { Label, type ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { FC, Fragment } from 'react';

import { FieldValidationErrors } from '../CustomFields/FieldValidationErrors';
import { getFormFieldAriaProps } from '../Functions/FormFieldAriaProps';

/**
 * Overrides the built-in Sitecore forms checkbox.
 * @see [Original Checkbox Implementation](https://github.com/Sitecore/jss/blob/v22.10.0/packages/sitecore-jss-react-forms/src/components/field-templates/checkbox.tsx)
 *
 * Markup and functionality should be 1:1 with the exception of `getFormFieldAriaProps`.
 *
 * @param props - Checkbox properties.
 * @returns A checkbox.
 */
export const BaseCheckbox: FC<ValueFieldProps> = (props) => {
  const { errors, field, onChange, tracker, value } = props;

  return (
    <Fragment>
      <Label {...props}>
        <input
          type="checkbox"
          className={field.model.cssClass}
          id={field.valueField.id}
          name={field.valueField.name}
          value="true"
          checked={value as unknown as boolean}
          onChange={(e) => onChange(field.valueField.name, e.target.checked, true, [])}
          onFocus={() => tracker.onFocusField(field, value)}
          onBlur={() => tracker.onBlurField(field, value, errors)}
          {...getFormFieldAriaProps(field, errors)}
        />
      </Label>
      <FieldValidationErrors {...props} />
    </Fragment>
  );
};
